/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import IPagingQuery from "../../../Basis/Queries/IPagingQuery";
import PromiseQuery from "../../../Basis/Queries/PromiseQuery";
import { nameof } from "../../../Basis/Utils/AnyUtil";
import FilterInfo from "../../DomainDrivenDesign/Queries/FilterInfo";
import FilterWertOption, { FilterWertOptionAls } from "../../DomainDrivenDesign/Queries/FilterWertOption";

export interface FindeFilterInfosFuerProvisionenCsvExportInput extends IPagingQuery {
    suchbegriff: string;
}

export default class FindeFilterInfosFuerProvisionenCsvExport extends PromiseQuery<FilterInfo[], FindeFilterInfosFuerProvisionenCsvExportInput> {
    public static queryName = "Exporte_FindeFilterInfosFuerProvisionenCsvExport";

    private static query = gql`
        query ${FindeFilterInfosFuerProvisionenCsvExport.queryName}($input: ${FindeFilterInfosFuerProvisionenCsvExport.queryName}) {
            ${FindeFilterInfosFuerProvisionenCsvExport.queryName}(input: $input) {
                ${nameof<FilterInfo>("feld")}
                ${nameof<FilterInfo>("zusatzfeldDefinitionId")}
                ${nameof<FilterInfo>("typ")}
                ${nameof<FilterInfo>("operatoren")}
                ${nameof<FilterInfo>("optionen")} {
                    ${nameof<FilterWertOption>("typ")}
                    ${nameof<FilterWertOption>("name")}
                    ${nameof<FilterWertOption>("als")} {
                        ${nameof<FilterWertOptionAls>("string")}
                        ${nameof<FilterWertOptionAls>("stringArray")}
                        ${nameof<FilterWertOptionAls>("integer")}
                        ${nameof<FilterWertOptionAls>("decimal")}
                        ${nameof<FilterWertOptionAls>("boolean")}
                        ${nameof<FilterWertOptionAls>("dateTime")}
                        ${nameof<FilterWertOptionAls>("enum")}
                        ${nameof<FilterWertOptionAls>("guid")}
                    }
                }
            }
        }
    `;

    public constructor() {
        super(FindeFilterInfosFuerProvisionenCsvExport.query);
    }

    public get name(): string {
        return FindeFilterInfosFuerProvisionenCsvExport.queryName;
    }
}
